import {
  Component,
  HostListener,
  Input,
  OnInit,
  SimpleChanges,
  PLATFORM_ID,
  Inject,
} from '@angular/core';

import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-toppers',
  templateUrl: './toppers.component.html',
  styleUrls: ['./toppers.component.scss'],
  standalone: false,
})
export class ToppersComponent implements OnInit {
  @Input() school: any = {};
  isBrowser: boolean = false;

  toppersData: any = [];
  lightColors: string[] = [
    '#E6EEFB',
    '#FCEAAD',
    '#D0FCE2',
    '#FFDABF',
    '#FAD4E2',
    '#E2F0CB',
    '#D9F3FC',
    '#FBE4D5',
  ];
  isAnimationRunning: boolean = true;
  isMobile: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  defaultTopperData: any[] = [
    {
      id: 0,
      name: 'School topper 1',
      imageUrl: '../../assets/images/topper1.png',
      backgroundColor: '#E6EEFB',
      percentage: 98,
      board: 'CBSE',
      rank: 1,
      class: 10,
      section: 'A',
    },
    {
      id: 1,
      name: 'School topper 2',
      imageUrl: '../../assets/images/topper2.png',
      backgroundColor: '#FCEAAD',
      percentage: 98,
      board: 'CBSE',
      rank: 1,
      class: 10,
      section: 'A',
    },
    {
      id: 2,
      name: 'School topper 3',
      imageUrl: '../../assets/images/topper3.png',
      backgroundColor: '#D0FCE2',
      percentage: 98,
      board: 'CBSE',
      rank: 1,
      class: 10,
      section: 'A',
    },
    {
      id: 3,
      name: 'School topper 4',
      imageUrl: '../../assets/images/topper4.png',
      backgroundColor: '#FFDABF',
      percentage: 98,
      board: 'CBSE',
      rank: 1,
      class: 10,
      section: 'A',
    },
  ];
  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.setToppersList();
    if (this.isBrowser) {
      this.checkScreenWidth();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      this.setToppersList();
    }
  }

  setToppersList(): void {
    let data = this.school.toppers || [];
    data = data.slice(0, 8);
    // this.toppersData = this.school.toppers;
    this.toppersData = data.map((topper, index) => ({
      ...topper,
      color: this.lightColors[index % this.lightColors.length],
    }));
  }

  toggleAnimation(): void {
    this.isAnimationRunning = !this.isAnimationRunning;
  }

  // @HostListener('window:resize', [])
  @HostListener('window:resize', [])
  onResize(): void {
    if (this.isBrowser) {
      this.checkScreenWidth();
    }
  }
  private checkScreenWidth(): void {
    this.isMobile = window.innerWidth <= 600;
  }
  // checkScreenWidth(): void {
  //   this.isMobile = window.innerWidth <= 600;
  // }
}
